// libraries
import valueInvoke from "@splitfire-agency/raiden-library/dist/libraries/utils/valueInvoke";

const defaultWhitelist = {
  "data.email": true,
  "data.token": true,
  "data.password": true,
};

export default function usersPasswordResetsSerializeCreate({
  fields,
  whitelist = defaultWhitelist,
}) {
  whitelist = valueInvoke(whitelist, defaultWhitelist);

  return {
    data: {
      email: whitelist["data.email"] ? fields?.data?.email : undefined,

      password: whitelist["data.password"] ? fields?.data?.password : undefined,

      token: whitelist["data.token"] ? fields?.data?.token : undefined,
    },
  };
}
